import { isEmpty, get, concat } from 'lodash';
import type from './DevelopmentOrder.type';

const initialState = {
  MeasurmentPomLibraries: null,
  DesignDetailData: null,
  SingleDesignDetailData: null,
  SampleAnnotationData: null,
  ProductTests: [],
  originalProductTests: [],
  productRefs: [],
  totalRecords_ProductTests: 0,
  ProductBomList: [],
  ProductColourList: [],
  libraryList: [],
  groupList: [],
  productList: [],
  productSuggestionList: [],
  commentSwitch: false,
  visibility: {},
  comment: '',
  ReportList: [],
  total_reportList: 0,
  allArchiveReport: [],
  totalArchiveCount: 0,
  testingAttributes: [],
  productRef_bom: [],
  testingAttributes_Length: 0,
  testRequirmentData: [],
  testingRequiment_Length: 0,
  previewData: {},
  suppliers: [],
  mainSamples: [],
  sampleLength: [],
  sampleColourWays: [],
  sampleSizes: [],
  sampleTabVisible: [],
  sampleAnnotationImage: [],
  sampleImage: [],
  sampleDetails: {},
  missingComponentDetails: [],
  documentOptionList: [
    { name: 'Documents', type: 'Folder', _id: 'Documents' },
    {
      name: 'Manuals And Documents',
      type: 'Folder',
      _id: 'Manuals And Documents',
    },
  ],
  designDocList: [],
  designSupportingDoc: [],
  designDocData: {},
  designDetailsPermission: {},
  searchValueFromTest: '',
  sampleSelectedIdsArray: {
    selectedItems: [],
  },
  sample_status: [],
  sampleTrakingDates: [],
  editDataForSampleTrackingDates: null,
  sampleTypeGroupsByProduct: [],
  testReportObj: {},
  sampleDetailsTabs: [
    {
      _id: 'comments',
      name: 'Comments',
      path: 'comments',
      status: false,
      switch: true,
      isSupplierSwitch: true,
      isSupplierTab: true,
    },
    {
      _id: 'annotateImages',
      name: 'Annotations',
      path: 'annotateImages',
      status: false,
      switch: true,
      isSupplierSwitch: true,
      isSupplierTab: true,
    },
    {
      _id: 'sampleSpecification',
      name: 'Specifications',
      path: 'sampleSpecification',
      status: false,
      switch: true,
      isSupplierSwitch: true,
      isSupplierTab: true,
    },
    {
      _id: 'photos',
      name: 'Images',
      path: 'photos',
      status: true,
      switch: true,
      isSupplierSwitch: true,
      isSupplierTab: true,
    },
    // {
    //   _id: "steps",
    //   name: "Next Steps",
    //   path: "steps",
    //   status: false,
    //   switch: true,
    //   isSupplierSwitch: false,
    //   isSupplierTab: false,
    // },
    {
      _id: 'components',
      name: 'Missing Components',
      path: 'components',
      status: false,
      switch: true,
      isSupplierSwitch: false,
      isSupplierTab: false,
    },
    // {
    //   _id: "supplierComment",
    //   name: "Supplier Comments",
    //   path: "supplierComment",
    //   status: false,
    //   switch: true,
    //   showBadge: true,
    // },
    // {
    //   _id: "supplierAnnotations",
    //   name: "Supplier Annotations",
    //   path: "supplierAnnotations",
    //   status: false,
    //   switch: true,
    // },
    // {
    //   _id: "supplierSpecifications",
    //   name: "Supplier Specifications",
    //   path: "supplierSpecifications",
    //   status: false,
    //   switch: true,
    // },
    // {
    //   _id: "supplierImages",
    //   name: "Supplier Images",
    //   path: "supplierImages",
    //   status: false,
    //   switch: true,
    // },
  ],
  sampleSpecificationData: [],
  unreadComments: 0,
  sampleSpecificationReducer: [],
  measurementProduct: null,
  productGrading: null,
  measurementData: null,
  CADSearchData: [],
  CADSpecData: null,
  SpecSearchData: [],
  Units: [],
  completionData: null,
  developmentOrderList: {},
  editedDevOrderData: null,
  editRule: null,
  adminUsers: [],
  companyUsers: [],
  reOrderData: null,
  reOrderList: [],
  allOpenProducts: [],
  sampleData: [],
  productGradingMeasurements: null,
  devOrderList: [],
  totalProductCount: 0,
  customModuleMenu: [],
  productCMDetails: null,
  customModulePermission: null,
  descProductList: [],
  historyList: [],
  historyTotalCount: 0,
  productIdentifierData: [],
  productPagesData: [],
  customModuleLoaderState: false,
  ProductCMPageList: [],
  ProductCMDependentList: [],
  productName: null,
  dppModuleMenu: [],
  systemCanvasModuleMenu: [],
  libraryCardMenu: [],
  CountList: '',
  bomDetailsBasedOnId: null,
};

const forComments = (state, action) => {
  let updateData = JSON.parse(JSON.stringify(state));
  if (action.payload && Object.keys(action.payload).length > 0) {
    const comment = action.payload?.comment ? action.payload?.comment : '';
    const isVisibleToSupplier = action.payload?.isVisibleToSupplier ? action.payload?.isVisibleToSupplier : {};
    const commentSwitch =
      action.payload?.isVisibleToSupplier && action.payload?.isVisibleToSupplier?.comment ? action.payload?.isVisibleToSupplier?.comment : false;
    updateData = {
      ...state,
      comment,
      visibility: isVisibleToSupplier,
      commentSwitch,
    };
  }
  return { ...updateData };
};

function formatNumbers(data) {
  if (!Array.isArray(data)) {
    return data;
  }

  return data.map((item) => {
    // Helper function to format a number
    const formatNumber = (value) => {
      const allowedPlaceholders = new Set(['/', 'N/A', 'NA', '-', 'N', 'A']);
      if (typeof value === 'string' || typeof value === 'number') {
        const parsed = parseFloat(value);
        if (allowedPlaceholders.has(value)) {
          return value; // Allow placeholders as-is
        }
        if (!Number.isNaN(parsed)) {
          return parsed.toFixed(3);
        }
      }
      return value;
    };
    return {
      ...item,
      requestedMeasurement: formatNumber(item.requestedMeasurement),
      revisedMeasurement: formatNumber(item.revisedMeasurement),
      tolMinus: formatNumber(item.tolMinus),
      grading: formatNumber(item.grading),
      tolPlus: formatNumber(item.tolPlus),
      actualMeasurement: formatNumber(item.actualMeasurement),
      supplierMeasurement: formatNumber(item.supplierMeasurement),
    };
  });
}

const DevelopmentOrder = (state = initialState, action) => {
  switch (action.type) {
    case type.GET_ORDER_MEASUREMENTS:
      return {
        ...state,
        MeasurmentPomLibraries: action.payload,
      };
    case type.MAEK_AS_COMPLETE:
      return {
        ...state,
        completionData: action.payload,
      };
    case type.GET_ORDER_DESIGN_DETAIL:
      return {
        ...state,
        DesignDetailData: action.payload,
      };
    case type.GET_SINGLE_DESIGN_DETAIL:
      return {
        ...state,
        SingleDesignDetailData: action.payload,
      };
    case type.GET_ORDER_SAMPLES:
      return {
        ...state,
        SampleAnnotationData: action.payload,
      };
    case type.GET_ORDER_TESTING:
      return {
        ...state,
        ProductTests: action.payload.doc,
        originalProductTests: action.payload.doc,
        totalRecords_ProductTests: action.payload.totalCount,
      };
    case type.UPDATE_NEW_ORDER_TESTING:
      return {
        ...state,
        ProductTests: action.payload,
      };
    case type.UPDATE_NEW_PRODUCT_BOM:
      return {
        ...state,
        testingAttributes: action.payload,
      };
    case type.SEARCH_TEXT:
      return {
        ...state,
        searchValueFromTest: action.payload,
      };
    case type.GET_ALL_PRODUCT_REF:
      return {
        ...state,
        productRefs: action.payload,
      };
    case type.GET_ALL_PRODUCT_REF_BOM:
      return {
        ...state,
        productRef_bom: action.payload,
      };
    case type.GET_TESTING_BOM_LIST:
      return {
        ...state,
        ProductBomList: action.payload,
      };
    case type.GET_TESTING_COLOUR_LIST:
      return {
        ...state,
        ProductColourList: action.payload,
      };
    case type.GET_ALL_LIBRARY_LIST:
      return {
        ...state,
        libraryList: action.payload,
      };
    case type.GET_ALL_GROUP_LIST:
      return {
        ...state,
        groupList: action.payload,
      };
    case type.GET_ALL_PRODUCTS:
      return {
        ...state,
        productSuggestionList: action.payload,
      };
    case type.GET_ALL_PRODUCT_LIST:
      return {
        ...state,
        productList: action.payload,
      };
    case type.GET_ALL_REPORTS:
      return {
        ...state,
        ReportList: action.payload,
        total_reportList: action.payload.totalCount,
      };
    case type.GET_ALL_ARCHIVE_REPORTS:
      return {
        ...state,
        allArchiveReport: action.payload,
        totalArchiveCount: action.payload.totalCount,
      };
    case type.DATA_FOR_PREVIEW:
      return {
        ...state,
        previewData: action.payload,
      };
    case type.TESTING_ATTRIBUTES:
      return {
        ...state,
        testingAttributes: action.payload !== null ? action.payload : [],
        testingAttributes_Length: action.payload !== null ? action.payload.totalCount : 0,
      };
    case type.FILTERED_TESTING_REPORTS:
      return {
        ...state,
        testReportObj: action.payload,
      };
    case type.CLEAR_REDUCER:
      return {
        ...state,
        MeasurmentPomLibraries: null,
        DesignDetailData: null,
        SampleAnnotationData: null,
        ProductTests: [],
        originalProductTests: [],
        productRefs: [],
        totalRecords_ProductTests: 0,
        libraryList: [],
        groupList: [],
        productList: [],
        productSuggestionList: [],
        ReportList: [],
        total_reportList: 0,
        allArchiveReport: [],
        totalArchiveCount: 0,
        testingAttributes: [],
        productRef_bom: [],
        testingAttributes_Length: 0,
        testRequirmentData: [],
        testingRequiment_Length: 0,
        previewData: {},
        searchValueFromTest: '',
        testReportObj: {},
        comment: '',
      };
    case type.TESTING_REQUIRMENTS:
      return {
        ...state,
        testRequirmentData: [...action.payload.doc],
        testingRequiment_Length: action.payload !== null ? action.payload.totalCount : 0,
      };
    case type.GET_THE_COMMENTS: {
      return forComments(state, action);
    }

    case type.GET_SUPPLIER:
      return {
        ...state,
        suppliers: action.payload,
      };

    case type.GET_MAIN_SAMPLES:
      return {
        ...state,
        mainSamples: action.payload,
      };

    case type.SAMPLE_LENGTH:
      return {
        ...state,
        sampleLength: action.payload,
      };

    case type.SAMPLE_COLOUR_WAY:
      return {
        ...state,
        sampleColourWays: action.payload,
      };

    case type.SAMPLE_SIZE:
      return {
        ...state,
        sampleSizes: action.payload,
      };

    case type.SAMPLE_PERMISSION: {
      const { payload } = action;
      const updatedPayload = state.sampleDetailsTabs.map((tabs) => {
        return tabs;
      });
      return {
        ...state,
        sampleTabVisible: updatedPayload,
      };
    }
    case type.SAMPLE_ANNOTATIONS_IMAGE:
      return {
        ...state,
        sampleAnnotationImage: action.payload,
      };
    case type.SAMPLE_IMAGE:
      return {
        ...state,
        sampleImage: action.payload,
      };
    case type.UPDATE_SAMPLE_SWITCHES:
      return {
        ...state,
        sampleTabVisible: action.payload,
      };
    case type.SAMPLE_DETAILS:
      if (action.payload) {
        action.payload = {
          ...action.payload,
        };
      }
      return {
        ...state,
        sampleDetails: action.payload,
      };
    case type.MISSING_COMPONENT:
      return {
        ...state,
        missingComponentDetails: action.payload,
      };
    case type.GET_SAMPLE_STATUS:
      return {
        ...state,
        sample_status: action.payload,
      };

    case type.SELECTED_IDS_ARRAY:
      return {
        ...state,
        sampleSelectedIdsArray: { ...action.payload },
      };

    case type.SAMPLE_TRAKING_ARRAY:
      return {
        ...state,
        sampleTrakingDates: action.payload,
      };
    case type.SAMPLE_TRACKING_DATES_DATA:
      return {
        ...state,
        editDataForSampleTrackingDates: action.payload,
      };
    case type.GET_SAMPLE_SPECIFICATION:
      return {
        ...state,
        sampleSpecificationData: action.payload,
      };
    case type.COUNT_UNREAD_COMMENTS:
      return {
        ...state,
        unreadComments: action.payload,
      };
    case type.DEVELOPMENT_ORDER_UNMOUNT:
      return {
        ...state,
        editDataForSampleTrackingDates: null,
      };
    case type.UNMOUNT_SAMPLE_DETAIL:
      return {
        ...state,
        sampleTabVisible: [],
        sampleDetails: {},
        sampleAnnotationImage: [],
      };
    case type.UNMOUNT_SAMPLE_SPECIFICATION_SIZE:
    case type.CLEAR_SPECIFICATION_REDUCER:
      return {
        ...state,
        sampleSpecificationReducer: [],
      };
    case type.ALL_DOCUMENT_OPTION_LIST:
      return {
        ...state,
        documentOptionList: action.payload.children,
      };
    case type.RESET_MODAL:
      return {
        ...state,
        documentOptionList: [...initialState.documentOptionList],
      };
    case type.UNMOUNT_DESIGN_DETAILS:
      return {
        ...state,
        designDocList: [],
      };
    case type.ALL_DESIGN_DETAILS:
      return {
        ...state,
        designDocList: !isEmpty(action.payload) ? action.payload.designs : [...initialState.designDocList],
        designDocData: action.payload,
      };
    case type.UPDATE_DESIGN_PDF_EXCLUDED_COMMENT: {
      const { designId, pdfExcludedComment } = action.payload || {};
      const updateDesigns = (list) => (list || []).map((d) => (d?._id === designId ? { ...d, pdfExcludedComment } : d));
      return {
        ...state,
        designDocList: updateDesigns(state.designDocList),
        designDocData: state.designDocData ? { ...state.designDocData, designs: updateDesigns(state.designDocData.designs) } : state.designDocData,
      };
    }
    case type.GET_DESIGN_SUPPORTING_DOC:
      return {
        ...state,
        designSupportingDoc: action.payload,
      };
    case type.DESIGN_DETAILS_PERMISSION:
      return {
        ...state,
        designDetailsPermission: action.payload,
      };
    case type.SAMPLE_SPECIFICATION: {
      const convertTo3Digit = formatNumbers(action.payload);
      return {
        ...state,
        sampleSpecificationReducer: convertTo3Digit,
      };
    }
    case type.MEASUREMENT_PRODUCT:
      return {
        ...state,
        measurementProduct: action.payload,
      };
    case type.PRODUCT_GRADING:
      return {
        ...state,
        productGrading: action.payload,
      };
    case type.PRODUCT_GRADING_MEASUREMENTS: {
      if (action.isScrolled && state.productGradingMeasurements?.specPomLibraries) {
        return {
          ...state,
          productGradingMeasurements: {
            ...action.payload,
            specPomAllCodes: state.productGradingMeasurements.specPomAllCodes,
            specPomLibraries: [...state.productGradingMeasurements.specPomLibraries, ...action.payload.specPomLibraries],
            scrollAppendedLibraries: action.payload.specPomLibraries,
          },
        };
      }
      return {
        ...state,
        productGradingMeasurements: { ...action.payload, scrollAppendedLibraries: null },
      };
    }
    /**
     * Carries the specPomAllCodes that a spec save just persisted back into the loaded document.
     * The autosave writes a fresh list on every save but dispatched nothing, so after deleting a
     * POM the store still listed its code and the import guards refused to re-add it until an
     * explicit Save refetched the group (BM-9510). A non-array payload is ignored rather than
     * stored, so a malformed save response cannot blank the guard list.
     *
     * The loaded rows are pruned to the same list. Both fields describe one document, and patching
     * only the codes left `specPomLibraries` still carrying the row the save had just deleted — the
     * row-seeding effect re-seeded from it, the deleted POM reappeared on screen and the trailing
     * autosave persisted it again, so re-importing it was refused as a duplicate (BM-9842).
     */
    case type.SPEC_POM_ALL_CODES: {
      if (!state.productGradingMeasurements || !Array.isArray(action.payload)) {
        return state;
      }
      /**
       * Identity is held stable when the membership is unchanged. productGradingMeasurements is a
       * dependency of performAutoSave, which the spec-save effect depends on in turn, so handing
       * back a fresh object for an unchanged list would re-run that effect, mark the rows dirty
       * and save again — and each save dispatches this action, restarting the cycle. Order is
       * ignored because the import guards only ever test membership.
       */
      const current = state.productGradingMeasurements.specPomAllCodes;
      if (Array.isArray(current) && current.length === action.payload.length) {
        const currentSet = new Set(current);
        if (action.payload.every((code) => currentSet.has(code))) {
          return state;
        }
      }
      /**
       * A row still being entered has no code yet and is absent from the persisted list by
       * definition, so it is kept rather than pruned out from under the user. The row array keeps
       * its identity when nothing is dropped, for the same reason the document does.
       */
      const loadedRows = state.productGradingMeasurements.specPomLibraries;
      let survivingRows = loadedRows;
      if (Array.isArray(loadedRows)) {
        const persistedCodes = new Set(action.payload);
        const keptRows = loadedRows.filter((row) => !row?.code || persistedCodes.has(row.code));
        survivingRows = keptRows.length === loadedRows.length ? loadedRows : keptRows;
      }
      return {
        ...state,
        productGradingMeasurements: {
          ...state.productGradingMeasurements,
          specPomAllCodes: action.payload,
          ...(survivingRows !== loadedRows && { specPomLibraries: survivingRows }),
        },
      };
    }
    case type.MEASUREMENT_DATA:
      return {
        ...state,
        measurementData: action.payload,
      };
    /**
     * Patches the per-grading-group hidden-size map in place, keyed by grading group id.
     *
     * Hiding a size on a grading group whose tab is not open is persisted by its own narrow
     * request, so the loaded measurement document never carries the change. Without this patch the
     * screen would keep rendering the stale server map until a full reload, and switching to that
     * group's tab would show the size the user just removed (BM-9510).
     */
    case type.MEASUREMENT_HIDDEN_SIZES_BY_GROUP:
      return state.measurementData
        ? {
            ...state,
            measurementData: {
              ...state.measurementData,
              hiddenSizesByGroup: { ...(state.measurementData.hiddenSizesByGroup || {}), ...action.payload },
            },
          }
        : state;
    case type.CAD_DATA:
      return {
        ...state,
        CADSearchData: action.payload,
      };
    case type.CLEAR_CAD_SEARCH:
      return {
        ...state,
        CADSearchData: [],
      };
    case type.CLEAR_PRODUCT_GRADING:
      return {
        ...state,
        productGradingMeasurements: null,
        CADSpecData: null,
      };
    case type.CLEAR_CAD_SPEC:
      return {
        ...state,
        CADSpecData: null,
      };
    case type.CAD_SPEC_DATA:
      return {
        ...state,
        CADSpecData: action.payload,
      };
    case type.SPEC_SEARCH:
      return {
        ...state,
        SpecSearchData: action.payload,
      };
    case type.UNITS:
      return {
        ...state,
        Units: action.payload,
      };
    case type.PRODUCT_LIST_DEVORDER:
      return {
        ...state,
        developmentOrderList: action.payload,
      };
    case type.DEVORDER_PRODUCT_LIST:
      const manipulatePimList = setArrayByCase(state?.devOrderList, action?.payload);

      return {
        ...state,
        devOrderList: manipulatePimList,
        totalProductCount: action?.payload?.totalCount,
      };
    case type.DEVORDER_PRODUCT_LIST_PATCH:
      return {
        ...state,
        devOrderList: patchListRows(state?.devOrderList, action?.payload),
      };
    case type.PRODUCT_EDIT_DATA:
      return {
        ...state,
        editedDevOrderData: action.payload,
      };
    case type.PRODUCT_EDIT_RULE:
      return {
        ...state,
        editRule: action.payload,
      };
    case type.ADMIN_USER:
      return {
        ...state,
        adminUsers: action.payload,
      };
    case type.COMPANY_USER:
      return {
        ...state,
        companyUsers: action.payload,
      };
    case type.REORDER_PRODUCT_DATA:
      return {
        ...state,
        reOrderData: action.payload,
      };
    case type.REORDER_LIST:
      return {
        ...state,
        reOrderList: action.payload,
      };
    case type.UNMOUNT_LIST:
      return {
        ...state,
        developmentOrderList: [],
      };
    case type.UNMOUNT_PRODUCT_MODAL:
      return {
        ...state,
        editRule: null,
        editedDevOrderData: null,
      };
    case type.GET_ALL_OPEN_PRODUCTS:
      return {
        ...state,
        allOpenProducts: action.payload,
      };

    case type.GET_SAMPLES:
      return {
        ...state,
        sampleData: action.payload,
      };
    case type.GET_SAMPLE_TYPE_GROUPS_BY_PRODUCT:
      return {
        ...state,
        sampleTypeGroupsByProduct: action.payload || [],
      };
    case type.CLEAR_SAMPLE_TYPE_GROUPS_BY_PRODUCT:
      return {
        ...state,
        sampleTypeGroupsByProduct: [],
      };

    case type.CUSTOM_MODULE_MENU:
      return {
        ...state,
        customModuleMenu: action.payload,
        customModuleLoaderState: false,
      };
    case type.GET_PRODUCT_CM_BY_ID:
      return {
        ...state,
        productCMDetails: action.payload,
      };
    case type.CLEAR_CUSTOM_LIB_DATA:
      return {
        ...state,
        productCMDetails: null,
        ProductCMPageList: [],
        ProductCMDependentList: [],
      };
    case type.CUSTOM_MODULE_PERMISSION_DATA:
      return {
        ...state,
        customModulePermission: action.payload,
      };
    case type.CLEAR_MEASUREMENT_GRADING_DATA:
      return {
        ...state,
        measurementProduct: null,
        measurementData: null,
        productGradingMeasurements: null,
        editedDevOrderData: null,
        CADSpecData: null,
      };
    case type.PRODUCT_LIST_MATCH:
      return {
        ...state,
        descProductList: action.payload,
      };
    case type.CLEAR_PRODUCT_LIST_MATCH:
      return {
        ...state,
        descProductList: [],
      };
    case type.GET_MULTI_SUBMIT_LIST:
      return {
        ...state,
        historyList: action?.payload?.requests,
        historyTotalCount: action?.payload?.totalCount,
      };
    case type.GET_PRODUCT_IDENTIFIER_LIST:
      return {
        ...state,
        productIdentifierData: action.payload,
      };

    case type.CLEAR_IDENTIFIER_REDUCER:
      return {
        ...state,
        productIdentifierData: [],
      };
    case type.PRODUCST_PAGES:
      return {
        ...state,
        productPagesData: action.payload,
      };
    case type.CUSTOM_MODULE_MENU_LOADING_STATE:
      return {
        ...state,
        customModuleLoaderState: action.payload,
      };
    case type.GET_PRODUCT_CM_PAGES:
      return {
        ...state,
        ProductCMPageList: action.payload,
      };
    case type.GET_PRODUCT_CM_DEPENDENT_LISTS:
      return {
        ...state,
        ProductCMDependentList: action.payload,
      };
    case type.SET_PRODUCT_NAME:
      return {
        ...state,
        productName: action.payload,
      };
    case type.DPP_MODULE_MENU:
      return {
        ...state,
        dppModuleMenu: action.payload,
      };
    case type.GET_ALL_COUNT_OPTIONS:
      return {
        ...state,
        CountList: action.payload ? action.payload : '',
      };
    case type.GET_BOM_DETAILS_BY_ID:
      return {
        ...state,
        bomDetailsBasedOnId: action.payload,
      };
    case type.CLEAR_BOM_EDIT_ADD:
      return {
        ...state,
        bomDetailsBasedOnId: null,
      };
    case type.FETCH_TYPE_BASED_CATEGORY:
      const dynamicKey = `catOptions${action.payload.categoryType}`; // assuming you pass this in the action
      return {
        ...state,
        [dynamicKey]: action.payload.data,
      };
    case type.SYSTEM_CANVAS_MODULE_MENU:
      console.log("action.payload", action.payload);
      return {
        ...state,
        systemCanvasModuleMenu: action.payload,
      };
    case type.LIBRARY_CARD_MENU:
      return {
        ...state,
        libraryCardMenu: action.payload,
      };
    default:
      return state;
  }
};

/**
 * Replace saved rows in the loaded product list, matched on `_id`.
 *
 * Row identity is load-bearing rather than incidental: the grid decides what to redraw by
 * reference, so a row this patch does not touch must come back as the very same object —
 * otherwise saving one product repaints the whole table.
 *
 * A row whose id is not on the loaded page is ignored rather than appended. Inserting it would
 * put it outside the list's sort order and make the page longer than the page size.
 *
 * The row is replaced wholesale, not merged, so a field the server has dropped does not linger
 * on screen from the previous copy.
 * @param {Array<object>} list the currently loaded rows
 * @param {Array<object>} rows the saved rows, in list shape
 * @returns {Array<object>} the list with matching rows replaced
 */
const patchListRows = (list, rows) => {
  if (!Array.isArray(list) || !Array.isArray(rows) || rows.length === 0) {
    return list;
  }

  const savedById = new Map();
  rows.forEach((row) => {
    const id = row && row._id ? String(row._id) : '';
    if (id) {
      savedById.set(id, row);
    }
  });

  if (savedById.size === 0) {
    return list;
  }

  return list.map((row) => savedById.get(row && row._id ? String(row._id) : '') || row);
};

/**
 * Merge a freshly-fetched product page into the existing list according to the request that
 * produced it (search / infinite-scroll / plain load).
 *
 * `data` is absent whenever the API returns no products (the controller answers the
 * not-found branch with a bare envelope), so both the accumulated list and the incoming
 * page are coerced to arrays before spreading — an undefined page previously threw
 * mid-reducer and left the grid unrendered.
 */
const setArrayByCase = (array, payload) => {
  const previousList = Array.isArray(array) ? array : [];
  const incomingPage = Array.isArray(get(payload, 'data')) ? payload.data : [];
  if (!isEmpty(get(payload, 'searchText')) && get(payload, 'isScrolled')) {
    return [...previousList, ...incomingPage];
  }
  if (!isEmpty(get(payload, 'searchText'))) {
    return incomingPage;
  }
  if (get(payload, 'isScrolled')) {
    return concat(previousList, incomingPage);
  }
  return incomingPage;
};

export default DevelopmentOrder;
